<template>
    <div>
        <div class="card">
            <div class="title">{{card.title}}</div>
            <div class="body">
                <div class="img">
                    <img :src="images[card.id]">
                </div>
                <div class="list">
                    <ul>
                        <li v-for="(item, index) in card.list" :key="index">
                            <div>
                                <img class="icon_plus" src="../../images/icon_list@2x.png">
                            </div>
                            <div class="insurance">
                                <span>{{item.insurance}}</span>
                            </div>
                            <div class="content">
                                <span>{{item.content}}</span>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="operate">
                    <div class="money">{{card.money}}</div>
                    <div class="unit">元/人/年</div>
                    <div>
                        <span class="btn" @click="handleClick(card)">查看详情</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        card: Object,
        default: () => {} 
    },
    data () {
        return {
            images: [
                '',
                require('../../images/p_normalA@2x.png'),
                require('../../images/p_normalB@2x.png'),
                require('../../images/p_normalC@2x.png'),
                require('../../images/p_selectedA@2x.png'),
                require('../../images/p_selectedB@2x.png'),
                require('../../images/p_selectedC@2x.png'),
            ]
        }
    },
    methods: {
        handleClick (card) {
            this.$emit('handleClick', card)
        }
    }
}
</script>

<style lang="scss" scoped>
.card {
    margin-bottom: 30px;
    padding: 34px 0 27px 38px;
    width: 100%;
    // height: 300px;
    box-shadow: 0px 2px 10px 0px rgba(78,132,248,0.08);
    font-family: DF King Gothic SC24;
    color: #333;
    background: #fff;

    .title {
        margin-bottom: 15px;
        font-size: 22px;
        font-weight: 600;
    }

    .body {
        display: flex;
    
        .img {
            margin-right: 23px;
            img {
                width: 248px;
                height: 209px;
            }
        }

        .list {
            position: relative;
            padding: 0 58px 0 0;
            font-size: 14px;
            
            ul li {
                display: flex;
                list-style: none;
                height: 30px;
                line-height: 30px;
            }

            .icon_plus {
                width: 10px;
                height: 10px;
            }

            .insurance {
                margin-left: 18px;
                width: 101px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
            }

            .content {
                margin-left: 14px;
                width: 378px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
            }

            &:after {
                content: '';
                position: absolute;
                top: 0;
                right: 0;
                width: 1px;
                background: #000;
                height: 211px;
                opacity: .1;
            }
        }

        .operate {
            flex: 1;
            text-align: center;
            .money {
                margin-top: 21px;
                font-family: Avenir Next;
                font-size: 34px;
                font-weight: 500;
                color: #F76D32;
            }

            .unit {
                margin: 15px 0 41px 0;
                font-size: 16px;
                font-family: Kozuka Gothic Pr6N;
                font-weight: normal;
                color: #333;
            }
                
            .btn {
                display: block;
                margin: 0 auto;
                width: 120px;
                height: 48px;
                line-height: 48px;
                color: #fff;
                background: #F87942;
                text-align: center;
                border-radius: 25px;
                cursor: pointer;
            }
        }
    }
}
</style>